import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';

export interface SaleItemBulkUpdateScheduleDialogData {
  currentDate: moment.Moment | null;
  minDate: Date;
}

@Component({
  selector: 'app-sale-item-bulk-update-schedule-dialog',
  templateUrl: './sale-item-bulk-update-schedule-dialog.component.html',
  styleUrls: ['./sale-item-bulk-update-schedule-dialog.component.scss'],
  standalone: false
})
export class SaleItemBulkUpdateScheduleDialogComponent implements OnInit {
  selectedDate: moment.Moment | null = null;
  minDate!: Date;

  constructor(
    public dialogRef: MatDialogRef<SaleItemBulkUpdateScheduleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SaleItemBulkUpdateScheduleDialogData
  ) {
    if (data) {
      this.selectedDate = data.currentDate ? moment(data.currentDate) : null;
      this.minDate = data.minDate;
    }
  }

  ngOnInit(): void {}

  onSave(): void {
    if (this.selectedDate) {
      this.dialogRef.close(this.selectedDate);
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
